import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M14 7.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "14",
  cy: "10",
  r: "1"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "14",
  cy: "14",
  r: "1"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M10 16.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
}, "3"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "10",
  r: "1"
}, "4"), /*#__PURE__*/_jsx("path", {
  d: "M7 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
}, "5"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "14",
  r: "1"
}, "6"), /*#__PURE__*/_jsx("path", {
  d: "M10 7.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm4 9c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0 4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
}, "7")], 'BlurCircularTwoTone');